import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import HomePage from "./components/HomePage";
import About from "./components/About";
import NearKualaLumpur from "./components/NearKualaLumpur";
import PopularDestinations from "./components/PopularDestinations";
import DiscoverNewPlace from "./components/DiscoverNewPlace";
import Banner from "./components/Banner";
import Partnerships from "./components/Partnerships";
import Footer from "./components/Footer";
import ThingsToDo from "./components/ThingsToDo";
import GlobalMap from "./components/GlobalMap";

function App() {
  return (
    <div>
      <div className="App">
        <HomePage />
      </div>
      {/* <br /> */}
      <div>
        <About />
      </div>
      <br />
      <div>
        <NearKualaLumpur />
      </div>
      <br />
      <br />
      <div>
        <PopularDestinations />
      </div>
      <br />
      <br />
      <div>
        <DiscoverNewPlace />
      </div>
      <br />
      <br />
      <div>
        <ThingsToDo />
      </div>
      <br />
      <br />
      <div>
        <GlobalMap />
      </div>
      <br />
      <br />
      <div>
        <Banner />
      </div>
      <br />
      <br />
      <div>
        <Partnerships />
      </div>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default App;
